import React, { useState } from "react";
import { User, UserPlus } from "lucide-react";

/* ===================== COMPONENTS ===================== */
import UserManagementTable from "../../../components/AdminComponents/UserManagementTable/ManagementTable";
import InviteUserModal from "../../../components/AdminComponents/UserManagementTable/InviteUserModal";
import { can } from "../../../utils/permissions";

/* ===================== STYLES ===================== */
import styles from "./AdminUsers.module.scss";

const AdminUsers = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("client-users");
  const [refreshKey, setRefreshKey] = useState(0);

  const refreshUsers = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <div className={styles["admin-users__page"]}>
      {/* HEADER PART */}
      <div className={styles["admin-users__header"]}>
        <div className={styles["admin-users__icon-wrapper"]}>
          <User size={24} strokeWidth={2.5} />
        </div>
        <div className={styles["admin-users__title-group"]}>
          <h2 className={styles["admin-users__title"]}>Users</h2>
          <p className={styles["admin-users__subtitle"]}>
            Manage team members and their access levels
          </p>
        </div>

        <div className={styles["admin-users__action-group"]}>
          {/* Custom modern button replacing the old <Button /> component to guarantee Rule 12 aesthetics */}
          {can("users", "invite-user") && (
            <button
              className={styles["admin-users__invite-btn"]}
              onClick={() => setIsModalOpen(true)}
            >
              <UserPlus size={18} strokeWidth={2.5} />
              Invite User
            </button>
          )}
        </div>
      </div>

      {/* TABLE COMPONENT */}
      <UserManagementTable
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        refreshKey={refreshKey}
      />

      {/* MODAL COMPONENT */}
      <InviteUserModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        userType={activeTab === "internal-users" ? "internal" : "client"}
        onInviteSuccess={refreshUsers}
      />
    </div>
  );
};

export default AdminUsers;
